import { cn as e } from "../utils/index.js";
import { Icon as t } from "./icons/icons.js";
import "./icons/index.js";
import { buttonVariants as n } from "./button.js";
import "react";
import { jsx as r, jsxs as i } from "react/jsx-runtime";
//#region src/components/pagination.tsx
function a({ className: t, ...n }) {
	return /* @__PURE__ */ r("nav", {
		role: "navigation",
		"aria-label": "pagination",
		"data-slot": "pagination",
		className: e("mx-auto flex w-full justify-center", t),
		...n
	});
}
function o({ className: t, ...n }) {
	return /* @__PURE__ */ r("ul", {
		"data-slot": "pagination-content",
		className: e("flex flex-row items-center gap-1", t),
		...n
	});
}
function s({ ...t }) {
	return /* @__PURE__ */ r("li", {
		"data-slot": "pagination-item",
		...t,
		className: e(t.disabled && "cursor-not-allowed text-(--neutral-400) *:pointer-events-none")
	});
}
function c({ className: t, isActive: i, size: a = "icon", ...o }) {
	return /* @__PURE__ */ r("a", {
		"aria-current": i ? "page" : void 0,
		"data-slot": "pagination-link",
		"data-active": i,
		className: e(n({
			variant: i ? "outline" : "ghost",
			size: a
		}), i && "text-(--seafoam-500) border-(--seafoam-500) rounded", "font-normal hover:bg-white hover:text-(--seafoam-500)", t),
		...o
	});
}
function l({ className: n, ...i }) {
	return /* @__PURE__ */ r(c, {
		"aria-label": "Go to previous page",
		size: "icon",
		className: e("gap-1 px-2.5 sm:pl-2.5", n),
		...i,
		children: /* @__PURE__ */ r(t, {
			name: "chevron_left",
			size: "sm"
		})
	});
}
function u({ className: n, ...i }) {
	return /* @__PURE__ */ r(c, {
		"aria-label": "Go to next page",
		size: "icon",
		className: e("gap-1 px-2.5 sm:pr-2.5", n),
		...i,
		children: /* @__PURE__ */ r(t, {
			name: "chevron_right",
			size: "sm"
		})
	});
}
function d({ className: n, ...a }) {
	return /* @__PURE__ */ i("span", {
		"aria-hidden": !0,
		"data-slot": "pagination-ellipsis",
		className: e("flex size-9 items-center justify-center", n),
		...a,
		children: [/* @__PURE__ */ r(t, {
			name: "more_horiz",
			size: "sm"
		}), /* @__PURE__ */ r("span", {
			className: "sr-only",
			children: "More pages"
		})]
	});
}
//#endregion
export { a as Pagination, o as PaginationContent, d as PaginationEllipsis, s as PaginationItem, c as PaginationLink, u as PaginationNext, l as PaginationPrevious };
